import { commonUtils } from 'redux/_common';
import {
	landscapeOrientedBooks,
	logInspectorViewLandscapeOrientedBooks,
} from './constants';
import { TMARPOLTank } from 'redux/app/marpol/@types';
import { TTaskTemplate } from 'redux/app/feedback/@types';

function getDate(log: any, type?: string) {
	let d = log.createdAt;
	if (type && type === 'LOG') {
		d = log.selectedDate;
	}
	return d;
}

export const getInitialContent = (bookId: string, timeNow: string) => {
	return (
		`<!DOCTYPE html>
           <html>
                <head>                
                    <link href="/tailwind.css" rel="stylesheet">     
                <style>
                    @page {
                        margin: ${landscapeOrientedBooks.includes(bookId)
			? '0rem'
			: '1.75rem'
		} ;
                        margin-bottom: ${landscapeOrientedBooks.includes(bookId)
			? '0.5rem'
			: '1.75rem'
		};
                        margin-top: ${landscapeOrientedBooks.includes(bookId)
			? '0rem'
			: '1.75rem'
		};
                        padding: ${landscapeOrientedBooks.includes(bookId)
			? '0rem'
			: '0.15rem'
		} ;
                        size: ${landscapeOrientedBooks.includes(bookId)
			? 'A4 landscape'
			: 'A4 portrait'
		};
                        @bottom-right {
                            content: "Page " counter(page) " of " counter(pages);
                        }   
                        @bottom-left {
                            content: "Printed on " "` +
		timeNow +
		`";
                        }   
                        @bottom-center {                   
                            content: "Wayship v1.0.62 | by - Volteo Maritime";
                        }     
                    }
                    .newpage {
                        break-before: page;
                    }
                    .wayship-table .theader th {
                        padding: 0.5rem 0.3rem;
                        border-radius: 4px;
                        height: 100%;
                    
                    }
                    .wayship-table td {
                        padding: 0.5rem;
                        line-height: 1.5rem;       
                    }
                    .orb1-table tr td:nth-child(1),
                    .orb4-table tr td:nth-child(1),
                    .annex6-table tr td:nth-child(1){
                        min-width: 108px !important;
                    }
                   
                    .orb1-table tr td:nth-child(2),
                    .orb1-table tr td:nth-child(3),
                    .orb4-table tr td:nth-child(2),
                    .orb4-table tr td:nth-child(3),
                    .annex6-table tr td:nth-child(2),
                    .annex6-table tr td:nth-child(3) {
                        min-width: 92px !important;
                    }

                    .grb1-table tr td:nth-child(1),
                    .grb1-table tr th:nth-child(1){
                        width: 98px !important;
                    }
                    .grb1-table tr td:nth-child(2),
                    .grb1-table tr th:nth-child(2){
                        width: 156px !important;
                    }
                    .grb1-table tr td:nth-child(3),
                    .grb1-table tr th:nth-child(3),
                    .grb1-table tr td:nth-child(4),
                    .grb1-table tr th:nth-child(4),
                    .grb1-table tr td:nth-child(5),
                    .grb1-table tr th:nth-child(5),
                    .grb1-table tr td:nth-child(6),
                    .grb1-table tr th:nth-child(6){
                        width: 96px !important;
                    }
                    .grb1-table tr td:nth-child(7),
                    .grb1-table tr th:nth-child(7){
                        width: 315px !important;
                    }

                    .rdg.fill-grid {
                        block-size: auto;
                    }

                    @media print {
                        
                        .orb1-table tr td, 
                        .orb1-table tr td *,
                        .orb1-table tr td .leading-7, 
                        .orb1-table tr td .leading-9,
                        .orb4-table tr td, 
                        .orb4-table tr td *,
                        .orb4-table tr td .leading-7, 
                        .orb4-table tr td .leading-9,
                        .annex6-table tr td, 
                        .annex6-table tr td *,
                        .annex6-table tr td .leading-7, 
                        .annex6-table tr td .leading-9,
                        .grb1-table tr td, 
                        .grb1-table tr td *,
                        .grb1-table tr td .leading-7, 
                        .grb1-table tr td .leading-9,
                        .ballast-tanks-operations-table tr td, 
                        .ballast-tanks-operations-table tr td *,
                        .ballast-tanks-operations-table tr td .leading-7, 
                        .ballast-tanks-operations-table tr td .leading-9, {
                            padding: 0rem !important;
                            line-height: 1.1 !important;
                        }

                        .grb2-table tr td, 
                        .grb2-table tr td *,
                        .grb2-table tr td .leading-7, 
                        .grb2-table tr td .leading-9,
                        .ballast-table tr td, 
                        .ballast-table tr td *,
                        .ballast-table tr td .leading-7, 
                        .ballast-table tr td .leading-9 {
                            padding: 0rem !important;
                        }

                        tr {
                            display: table-row;
                            vertical-align: inherit;
                            border-color: inherit;
                        }
                        .modified-table {
                            margin-top: -1.5rem !important;
                        }
                        table td {
                            border: 1px solid gray;
                        }
                        .annex6-table .p-3,
                        .grb1-table .p-3,
                        .grb2-table .p-3{
                            padding: 0 !important;
                        }
                        .annex6-table .leading-7,
                        .annex6-table .leading-9,
                        .grb1-table .leading-7,
                        .grb1-table .leading-9,
                        .grb2-table .leading-7,
                        .grb2-table .leading-9,
                        
                        .p-12 {
                            padding-left: 0 !important;
                            padding-right: 0 !important;
                        }
                        .annex6-table .m-px,
                        .grb1-table .m-px,
                        .grb2-table .m-px,
                        .ballast-table .m-px {
                            margin: 0rem !important;
                        }
                        .ballast-table.modified-table {
                            margin-top: -2.5rem !important;
                        }


                        div.py-6.ws-scroll {
                            padding: 0 !important;
                            padding-top: 2px !important;
                        }
                        div.px-6.mb-12 {
                            margin-bottom: 0 !important;
                        }
                        .grb1-table thead {
                            padding-top: 0.75rem !important;
                        }
                        .wayship-table .theader th,
                        .orb4-table th .p-3 {
                            padding: 0rem !important;
                        }
                        table.orb1-table td,
                        table.orb4-table td,
                        table.grb1-table td,
                        table.ballast-tanks-operations-table td, {
                            border-radius: 0.12rem !important;
                        } 
                        .grb2-table th .p-3,
                        .ballast-table th .p-3,
                        .ballast-tanks-operations-table th .p-3 {
                            padding: 0 !important;
                        }
                        .grb2-table tr td:nth-child(1),
                        .grb2-table tr th:nth-child(1){
                            text-align:center;
                            min-width: 86px !important;
                            
                        }
                        .grb2-table tr td:nth-child(2),
                        .grb2-table tr th:nth-child(2){
                            text-align:center;
                            min-width: 150px !important;
                            
                        }
                        .grb2-table tr td:nth-child(3),
                        .grb2-table tr th:nth-child(3){
                            text-align:center;
                            min-width: 77px !important;
                            
                        }
                        .grb2-table tr td:nth-child(4),
                        .grb2-table tr th:nth-child(4),
                        .grb2-table tr td:nth-child(5),
                        .grb2-table tr th:nth-child(5),
                        .grb2-table tr td:nth-child(6),
                        .grb2-table tr th:nth-child(6) {
                            text-align:center;
                            min-width:120px !important;
                        }
                        .ballast-table tr td:nth-child(1),
                        .ballast-table tr td:nth-child(2),
                        .ballast-table tr th:nth-child(1),
                        .ballast-table tr th:nth-child(2){
                            width: 146px !important;
                            border-radius: 4px !important;
                        }

                        .ballast-tanks-operations-table tr td:nth-child(1) > div,
                        .ballast-tanks-operations-table tr th:nth-child(1) > div
                         {
                            max-width: 44px !important;
                            font-size: 9px !important;
                        }

                        .ballast-tanks-operations-table tr td,
                        .ballast-tanks-operations-table tr th
                         {
                            max-width: 52px !important;
                            font-size: 9px !important;
                            text-wrap: wrap !important;
                        }
                        

                        .ballast-tanks-operations-table tr td:nth-child(2),
                        .ballast-tanks-operations-table tr th:nth-child(2) {
                            max-width: 40px !important;
                            font-size: 9px !important;

                        }

                        .ballast-tanks-operations-table tr td:nth-child(14),
                        .ballast-tanks-operations-table tr th:nth-child(14) {
                            max-width: 40px !important;
                        }            
                       

                        .ballast-tanks-operations-table.wayship-table td {
                            padding: 0.1rem !important;
                            line-height: 1 !important;
                            border-radius: 2px !important;
                        }

                        .ballast-tanks-operations-table {
                            border-collapse: collapse !important;
                            border-spacing:0 !important;
                        }  

                        .wayship-table.ballast-tanks-operations-table td {
                            padding: 0rem !important;
                            overflow-wrap: break-word;
                        }
                        .ballast-tanks-operations-table .signature {
                            word-break: break-all !important
                        }
                        .print-text-sm{
                            font-size: 14px;
                        }
    
                    }
                </style>
                </head>
                <body>
                    <div id="mountHere"></div>
                </body>
            </html>`
	);
};

export const getLogInspectorViewIFrameInitialContent = (
	bookId: string,
	timeNow: string
) => {
	let bookIdBasedClass = '';
	switch (bookId) {
		case 'gmdssRadioConfig':
		case 'portLogConfig': {
			bookIdBasedClass = `
            #print-table tr td:nth-child(1),
            #print-table tr th:nth-child(1) {
                width: 80.6px !important;
            }

       
    `;

			break;
		}
		case 'engineLogConfig': {
			break;
		}

		default:
			bookIdBasedClass = '';
	}

	return (
		`<!DOCTYPE html>
    <html>
        <head>
            <link href="/tailwind.css" rel="stylesheet">
            <style>
                @page {
                    margin: 0rem;
                    padding: ${bookId === 'engineLogConfig' ? '0rem' : '0.5rem'
		}; 
                    size: ${logInspectorViewLandscapeOrientedBooks.includes(bookId)
			? 'A4 landscape'
			: 'A4 portrait'
		};
                    @bottom-right {
                        content: "Page " counter(page) " of " counter(pages);
                    }
            
                    @bottom-left {
                        content: "Printed on " "` +
		timeNow +
		`";
                    }   
                }
                .newpage {
                    break-before: page;
                }
              
                @media print {
                    ${bookIdBasedClass}
                }
                   
                
            </style>
        </head>
        <body>
            <div id="mountHereLogInspector${bookId}">
            </div>
        </body>
    </html>`
	);
};

const getFilteredTanks = (
	tanks: TMARPOLTank[],
	filterKey: string,
	filterBy: string[]
) => {
	let filteredTanks =
		filterKey && filterBy
			? tanks?.filter((tank) => {
				const currentTankKeyValue =
					filterKey in tank ? (tank as any)[filterKey] : undefined;
				return (
					currentTankKeyValue &&
					filterBy.includes(currentTankKeyValue)
				);
			})
			: tanks;

	return filteredTanks;
};

const searchFilter = (list: TTaskTemplate[], query: string): TTaskTemplate[] => {
    if (!query || !list || !list.length) return [];
    query = query.toUpperCase();
    return list.filter(({ id, title, type }) => {
        if (
            id.toUpperCase().indexOf(query) > -1 ||
            title.toUpperCase().indexOf(query) > -1 ||
            type.toUpperCase().indexOf(query) > -1
        ) {
            return true;
        } else {
            return false;
        }
    });
}

const getAPINameForDocumentConfig = (
	documentType: 'CHECKLIST' | 'LOG' | 'PERMIT' | undefined
) => {
	switch (documentType) {
		case 'CHECKLIST':
			return 'checklists';
		case 'LOG':
			return 'log-configs';
		case 'PERMIT':
			return 'permit-configs';
		default:
			return undefined;
	}
};

export { getDate, getFilteredTanks, getAPINameForDocumentConfig, searchFilter };
